import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Person } from '../types/person.interface';

@Injectable({
  providedIn: 'root'
})
export class PeopleService {

  bareUri: string = environment.PEOPLE_BASE;

  constructor(private http: HttpClient) { }

  checkDocumentExists(documentNumber: string): Observable<Person> {
    return this.http.get<Person>(`${this.bareUri}/documentExists/${documentNumber}`);
  }
}
